import { Tabs as MuiTabs } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useEffect, useRef, useState } from 'react'
import Tab from './Tab'
import { Icon } from 'packages/eid-icons'

const ScrollableDiv = styled('div')(() => ({
    overflow: 'scroll !important',
    '&::-webkit-scrollbar': {
        display: 'none !important',
        width: '0',
        height: '0',
    },
}))

const StyledTabs = styled(MuiTabs)(({ theme }) => ({
    scrollBehavior: 'smooth',
}))

const HorizontalTabs = (props) => {
    const OFFSET = props.offset ? props.offset : 50
    const ref = useRef(null)
    const [scrollableDiv, setScrollableDiv] = useState(null)
    const [scrollLeft, setScrollLeft] = useState(0)

    const handleScrollKeyDown = (event, direction) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            if (!scrollableDiv) return
            const { y } = scrollableDiv.getBoundingClientRect()
            const delta = direction === 'left' ? -OFFSET : OFFSET
            scrollableDiv.scrollTo(scrollableDiv.scrollLeft + delta, y)
        }
    }

    const scrollTabs = (direction) => {
        if (!scrollableDiv) return
        const { y } = scrollableDiv.getBoundingClientRect()
        const delta = direction === 'left' ? -OFFSET : OFFSET
        scrollableDiv.scrollTo(scrollableDiv.scrollLeft + delta, y)
    }
    useEffect(() => {
        if (ref?.current) {
            setScrollableDiv(ref.current.firstChild)
            setScrollLeft(ref.current.firstChild.scrollLeft)
        }
    }, [])
    useEffect(() => {
        if (scrollableDiv) {
            const handleScroll = () => {
                setScrollLeft(scrollableDiv.scrollLeft)
            }
            scrollableDiv.addEventListener('scroll', handleScroll)
            return () => {
                scrollableDiv.removeEventListener('scroll', handleScroll)
            }
        }
    })
    return (
        <>
            {props?.customScroll ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {scrollLeft > 0 && (
                        <Icon
                            direction="left"
                            sx={{
                                width: '3rem',
                                height: '3rem',
                                cursor: 'pointer',
                            }}
                            name="Arrow"
                            role="button"
                            tabIndex={0}
                            aria-label="Scroll tabs left"
                            onClick={() => scrollTabs('left')}
                            onKeyDown={(event) =>
                                handleScrollKeyDown(event, 'left')
                            }
                        />
                    )}
                    <ScrollableDiv>
                        <StyledTabs
                            ref={ref}
                            {...props}
                            variant="standard"
                            scrollButtons={false}
                        />
                    </ScrollableDiv>

                    {scrollLeft <
                        scrollableDiv?.scrollWidth -
                            scrollableDiv?.offsetWidth && (
                        <Icon
                            direction="right"
                            sx={{
                                width: '3rem',
                                height: '3rem',
                                cursor: 'pointer',
                            }}
                            name="Arrow"
                            role="button"
                            tabIndex={0}
                            aria-label="Scroll tabs right"
                            onClick={() => scrollTabs('right')}
                            onKeyDown={(event) =>
                                handleScrollKeyDown(event, 'right')
                            }
                        />
                    )}
                </div>
            ) : (
                <StyledTabs {...props} />
            )}
        </>
    )
}

HorizontalTabs.Tab = Tab

export default HorizontalTabs
